import { log } from '@/log'
import { PaymentMethod } from '@spa/store/modules/orderHistory/types'
import { getCarrierProviderLabel } from './carrier_provider'
import { getCvsTypeLabel } from './cvs_type'

/**
 * FIXME: 「支払い方法」の名称が複数箇所で個別に定義され、散在している
 *
 * サーバー側のデータ定義に表示も全て統合させ、clientでは個別に考慮しなくて良いようにするべき.
 * /api/common/payment/setting を拡張するなどして、購入以外の文脈(再注文など)でも、
 * 支払い方法の設定情報等を取得できるようにしたい.
 *
 * @see ViewItem.paymentLabel
 * @see src/Model/Payment/Kind
 * @see \App\ReadModel\Subscription\Contracted\Payment::methodKind
 */
export function getPaymentLabel(payment: PaymentMethod): string {
  switch (payment.kind) {
    case 'cash-on-delivery':
      return '代金引換'
    case 'creditcard':
    case 'creditcard3d':
      return 'クレジットカード'
    case 'np-postpay':
      return 'NP後払い（コンビニ／LINE Pay対応）'
    case 'atone':
      return 'atone 翌月まとめて後払い'
    case 'paidy':
      return 'あと払い (ペイディ)'
    case 'cvs-number':
      return payment.cvs_type ?
        `コンビニ決済 (前払い) - ${getCvsTypeLabel(payment.cvs_type)}` :
        'コンビニ決済 (前払い)'
    case 'carrier':
      log.debug(payment)

      return payment.carrier_provider ?
        `携帯キャリア決済 - ${getCarrierProviderLabel(payment.carrier_provider)}` :
        '携帯キャリア決済'
    case 'webmoney':
      return 'PayPay決済'
    case 'none':
      return 'なし'
    default:
      log.error(`invalid paymentType`, payment)

      return '未定'
  }
}
